import tableRooms from './tableRooms';
import tableRoomsSelectable from './tableRoomsSelectable';

export default {
  title: 'Rooms',
  attributeName: 'rooms',
  getURL: 'mainHubs/mainHubId/roomsPaginated',
  createURL: 'mainHubs/mainHubId/rooms',
  updateURL: 'mainHubs/mainHubId/rooms',
  removeURL: 'mainHubs/mainHubId/rooms',
  idAttribute: 'id',
  sessionParams: ['mainHubId'],
  tableConfig: tableRoomsSelectable,
  noArea: true,
  noTitle:true,
  autoUpdate: true,
};
